<!-- HEADER ROW -->
<div id="sldEditorHeader">STYLE EDITOR</div>

<div id="sldEditorContent">
    <!-- TEMPLATES -->
    <label id="sldMenuLabel" for="sldmenu">Choose existing template:</label>
    <select name="sldmenu" id="sldmenu" (change)="$event.stopPropagation();sldSelectionChanged()">
        <option *ngFor="let sld of slds">{{sld.name}}</option>
    </select>
    <i class="material-icons sldButton" *ngIf="templateSld && !templateSld.builtin" 
        title="Delete template" aria-label="Delete template" 
        (click)="deleteSld()">delete</i>

    <!-- STYLE DEFINITIONS -->
    <div id="sldEditTitle">Customize style 
        <i class="material-icons sldColormapTableButton" *ngIf="editorSld && !editorSld.singleBand"
            title="Show single-band style settings" aria-label="Show single-band style settings"
            (click)="$event.stopPropagation();showSingleBand()">photo</i>
        <i class="material-icons sldColormapTableButton" *ngIf="editorSld && editorSld.singleBand"
            title="Show multi-band style settings" aria-label="Show multi-band style settings"
            (click)="$event.stopPropagation();showMultiBand()">photo_library</i>
    </div>

    <div id="singleBandSelectionDiv" *ngIf="editorSld && editorSld.singleBand">
        <table id="singleBandTable" class="channelSelectionTable">
            <tr class="channelSelectionTableHeaderTR">
                <th class="channelSelection channelSelectionLabelTH"></th>
                <th class="channelSelection channelSelectionBandTH">Band number</th>
                <th class="channelSelection channelSelectionMinTH">Minimum value</th>
                <th class="channelSelection channelSelectionMaxTH">Maximum value</th>
            </tr>
            <tr class="channelSelectionTableDataTR">
                <td class="channelSelection channelSelectionLabelTD">Gray</td>
                <td class="channelSelection channelSelectionBandTD">
                    <input class="channelSelectionBandInput" value="{{editorSld.gray?.bandnumber}}" id="sldgrayband" type="text"/>
                </td>
                <td class="channelSelection channelSelectionMinTD">
                    <input class="channelSelectionMinInput" value="{{editorSld.gray?.minvalue}}" id="sldgraybandmin" type="text"/>
                </td>
                <td class="channelSelection channelSelectionMaxTD">
                    <input class="channelSelectionMaxInput" value="{{editorSld.gray?.maxvalue}}" id="sldgraybandmax" type="text"/>
                </td>
            </tr>
        </table>
        <div id="singleBandInfo">If band limits are used define colormap for interval 0-255. Define both lower and upper limits.</div>
        @if(editorSld.colormap.length == 0) {
            <i (click)="addColormapTemplate()" 
                class="material-icons sldButton addTemplateIcon left" 
                aria-label="Add colormap template" 
                title="Add colormap template">add</i>
        }
        @if(editorSld.colormap.length > 0) {
            <div id="sldColorMapDiv">
                <div id="sldColormapTitle">Customize colormap</div>
                <div id="sldTableDiv">
                    <table id="sldTable">
                        <tr class="sldHeaderRow">
                            <th class="sldHeaderCell">Pixel value</th>
                            <th class="sldHeaderCell">Color</th>
                            <th class="sldHeaderCell">Opacity</th>
                            <th></th>
                        </tr>
                        <tr class="sldDataRow" *ngFor="let cm of editorSld.colormap">
                            <td class="sldDataCell">
                                <input class="sldQuantityInput" type="number" value="{{cm.quantity}}"/>
                            </td>
                            <td class="sldDataCell">
                                <input class="sldColorInput" type="color" value="{{cm.color}}"/>
                            </td>
                            <td class="sldDataCell">
                                <!-- onchange="updateColorAlpha(this.value);" -->
                                <input class="sldAlphaInput" type="range" min="0" max="1" step="0.1" value="{{cm.alpha}}">
                            </td>
                            <td class="sldButtonCell" 
                                (click)="newSldRowBelow($event)" 
                                aria-label="Add row below" 
                                title="Add row below">
                                <i class="material-icons sldColormapTableButton">vertical_align_bottom</i>
                            </td>
                            <td class="sldButtonCell" 
                                (click)="newSldRowAbove($event)" 
                                aria-label="Add row above" 
                                title="Add row above">
                                <i class="material-icons sldColormapTableButton">vertical_align_top</i>
                            </td>
                            <td class="sldButtonCell" 
                                (click)="deleteSldRow($event)" 
                                aria-label="Delete row" 
                                title="Delete row">
                                <i class="material-icons sldColormapTableButton">clear</i>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        }
    </div>
    <div id="multiBandSelectionDiv" *ngIf="editorSld && !editorSld.singleBand">
        <table id="singleBandTable" class="channelSelectionTable">
            <tr class="channelSelectionTableHeaderTR">
                <th class="channelSelection channelSelectionLabelTH"></th>
                <th class="channelSelection channelSelectionBandTH">Band number</th>
                <th class="channelSelection channelSelectionMinTH">Minimum value</th>
                <th class="channelSelection channelSelectionMaxTH">Maximum value</th>
            </tr>
            <tr class="channelSelectionTableDataTR">
                <td class="channelSelection channelSelectionLabelTD">Red</td>
                <td class="channelSelection channelSelectionBandTD">
                    <input class="channelSelectionBandInput" value="{{editorSld.red?.bandnumber}}" id="sldredband" name="sldredband" type="number"/>
                </td>
                <td class="channelSelection channelSelectionMinTD">
                    <input class="channelSelectionMinInput" value="{{editorSld.red?.minvalue}}" id="sldredbandmin" name="sldredbandmin" type="number"/>
                </td>
                <td class="channelSelection channelSelectionMaxTD">
                    <input class="channelSelectionMaxInput" value="{{editorSld.red?.maxvalue}}" id="sldredbandmax" name="sldredbandmax" type="number"/>
                </td>
            </tr>
            <tr class="channelSelectionTableDataTR">
                <td class="channelSelection channelSelectionLabelTD">Green</td>
                <td class="channelSelection channelSelectionBandTD">
                    <input class="channelSelectionBandInput" value="{{editorSld.green?.bandnumber}}" id="sldgreenband" name="sldgreenband" type="number"/>
                </td>
                <td class="channelSelection channelSelectionMinTD">
                    <input class="channelSelectionMinInput" value="{{editorSld.green?.minvalue}}" id="sldgreenbandmin" name="sldgreenbandmin" type="number"/>
                </td>
                <td class="channelSelection channelSelectionMaxTD">
                    <input class="channelSelectionMaxInput" value="{{editorSld.green?.maxvalue}}" id="sldgreenbandmax" name="sldgreenbandmax" type="number"/>
                </td>
            </tr>
            <tr class="channelSelectionTableDataTR">
                <td class="channelSelection channelSelectionLabelTD">Blue</td>
                <td class="channelSelection channelSelectionBandTD">
                    <input class="channelSelectionBandInput" value="{{editorSld.blue?.bandnumber}}" id="sldblueband" name="sldblueband" type="number"/>
                </td>
                <td class="channelSelection channelSelectionMinTD">
                    <input class="channelSelectionMinInput" value="{{editorSld.blue?.minvalue}}" id="sldbluebandmin" name="sldbluebandmin" type="number"/>
                </td>
                <td class="channelSelection channelSelectionMaxTD">
                    <input class="channelSelectionMaxInput" value="{{editorSld.blue?.maxvalue}}" id="sldbluebandmax" name="sldbluebandmax" type="number"/>
                </td>
            </tr>
        </table>
        <div id="multiBandInfo">If limits are used they must be defined for all three bands. Define both lower and upper limits.</div>
    </div>
    <div id="sldEditorButtonRow">
    @if (sldEditorItem?.defaultSld) {
        <span class="material-icons sldButton resetDefaultIcon right"
            title="Reset default style" aria-label="Reset default style" 
            (click)="resetDefaultSld()">undo</span>
    } 
    <span (click)="applySld()" 
        class="material-icons sldButton applySldIcon right" 
        aria-label="Apply settings" 
        title="Apply settings">done</span>
    <span (click)="saveSld()" 
        class="material-icons sldButton saveSldIcon right" 
        aria-label="Save settings" 
        title="Save settings">save</span>
    </div>
</div>